/**
 * Created by hp on 2017/5/31.
 */
import React from 'react';
import ErrorMessage from './ErrorMessage'

import '../../styles/messages/RewardMessage.css';
import {removeAds, renderMoney} from '../../utils';
import redpackPng from '../../images/redPacket3x.png';

export default class RewardMessage extends React.PureComponent {
    render() {
        try {
            const {message, handleReward} = this.props;
            if(message.meta && message.meta.sender){
                // 新版打赏样式
                const {meta} = message;
                return <div className="reward-message" onClick={e => handleReward(message.meta.receiver)}>
                    <img src={redpackPng} alt="红包"/>
                    <span className="tip text-ellipsis">
        			{removeAds(meta.sender.nickname)}
                        {meta.tip}
        		</span>
                    <span className="money">
        			{meta.fee / 100}元
        		</span>
                </div>
            }

            return <div className="reward-message text-ellipsis">
                <img src={redpackPng} alt="红包"/>
                <span>{removeAds(message.content)}</span>
            </div>
        } catch (e) {
            return <ErrorMessage/>
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/messages/RewardMessage.js